import {Badge, Button, Image} from 'antd-mobile';
import React, {useMemo} from 'react';
import styles from './home.module.scss';
import {useTranslation} from 'react-i18next';
interface HomeSideBonusProps {
  count: number;
  onClick?: () => void;
}

const HomeSideBonus = ({count, onClick}: HomeSideBonusProps) => {
  const {i18n} = useTranslation();

  const homeBonusImage = useMemo(() => {
    return i18n.language === 'bn_BD'
      ? require('@/assets/icons/home/home-bonus-bn_BD.png')
      : require('@/assets/icons/home/home-bonus.png');
  }, [i18n.language]);
  return (
    <div className={styles['home-side-bonus']}>
      <Badge content={count > 0 ? Badge.dot : null} color="#F00">
        <Button
          className="p-0 bg-transparent size-16 rounded-full"
          onClick={onClick}>
          <Image src={homeBonusImage} />
        </Button>
      </Badge>
    </div>
  );
};

export default HomeSideBonus;
